export default "__VITE_ASSET__0vtuKcuC__"